<template>
	<div class="pop pop-rule" :class="{ show: rulePop }">
		<div class="cont">
			<div class="title"></div>
			<div class="scroll-area" id="rule-scroll">
				<div class="txt-wrap" v-html="$t('rule')"></div>
			</div>
			<a class="pop-close" @click="popClose('rule')" href="javascript:void(0);"></a>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapState } from 'vuex'
	import BScroll from '@better-scroll/core'
	import ScrollBar from '@better-scroll/scroll-bar'
	import MouseWheel from '@better-scroll/mouse-wheel'
	import ObserveDOM from '@better-scroll/observe-dom'
	BScroll.use(ObserveDOM)
	BScroll.use(ScrollBar)
	BScroll.use(MouseWheel)
	export default {
		name: 'pop-rule',
		mounted() {
			this.initScroll()
		},
		data() {
			return {
				scroll: null,
			}
		},
		components: {},
		computed: {
			...mapState(['pop']),
			rulePop() {
				return this.$store.state.pop.rule
			}
		},
		watch: {
			rulePop(val) {
				if (val) {
					this.initScroll()
				}
			}
		},
		methods: {
			...mapMutations(['popOpen', 'popClose', 'updateState']),
			initScroll() {
				this.scroll && this.scroll.destroy()
				setTimeout(() => {
					this.scroll = new BScroll('#rule-scroll', {
						scrollY: true,
						scrollbar: {
							fade: false
						},
						mouseWheel: {
							speed: 20,
							invert: false,
							easeTime: 300
						},
						observeDOM: true
					})
				}, 200)
			}
		}
	}
</script>
